var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.imprint)?_c('v-row',[_c('v-col',{staticClass:"white--text",attrs:{"cols":"12"},domProps:{"innerHTML":_vm._s(_vm.imprint.content)}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }